import { Card, CardActionArea, Grid } from "@mui/material";
import { setRefererInternal } from "modules/referer";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";
import theme from "theme";

type GameExtentionCardProps = {
  productId: string;
  thumbnailUrl: string;
  name: string;
  category: string;
  price: number;
  to: string;
  referer:
    | "store-top-page-list-new"
    | "store-top-page-list-extention"
    | "store-top-page-list-other";
};

const GameExtentionCard = ({
  productId,
  thumbnailUrl,
  price,
  name,
  category,
  to,
  referer,
}: GameExtentionCardProps) => {
  const [t] = useTranslation();

  const onClickCard = useCallback(() => {
    setRefererInternal({ productId, referer });
  }, [productId, referer]);

  return (
    <Grid sx={{ width: "100%" }} item xs={12} sm={6} md={4}>
      <Card
        sx={{
          height: "100%",
          margin: { md: "0 12px", sm: "0 8px", xs: "0 6px" },
          flex: 1,
          background: "#2a2a2a",
          borderRadius: "8px",
        }}
      >
        <CardActionArea
          component={Link}
          to={to}
          onClick={onClickCard}
          sx={{
            display: "grid",
            justifyContent: "start",
            gridTemplateColumns: {
              md: "160px 1fr ",
              xs: "minmax(118px, calc(118 / 358 * 100%)) auto ",
            },
            height: "100%",
          }}
        >
          <Thumbnail>
            <img src={thumbnailUrl} alt="" />
          </Thumbnail>
          <CardBody>
            <CategoryLabel>{category}</CategoryLabel>
            <Name>{name}</Name>
            <Price>
              {price === 0 ? t("無料") : "¥" + price.toLocaleString("ja-JP")}
            </Price>
          </CardBody>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

const Thumbnail = styled.div`
  width: 100%;
  height: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const CardBody = styled.div`
  padding: 12px;
  font-family: sans-serif;
`;

const CategoryLabel = styled.span`
  padding: 2px 4px;
  font-weight: 600;
  font-size: 12px;
  white-space: nowrap;
  color: #fff;
  background-color: #000;
`;

const Name = styled.div`
  margin-top: 4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 14px;
  line-height: 1.4;
  ${theme.breakpoints.down("sm")} {
    font-size: 14px;
    -webkit-line-clamp: 1;
  }
`;
const Price = styled.div`
  margin-top: 4px;
  font-size: 14px;
  font-weight: bold;
`;

export default memo(GameExtentionCard);
